import { render, staticRenderFns } from "./CreateBdoCardFromTemplate.vue?vue&type=template&id=10f65118&"
import script from "./CreateBdoCardFromTemplate.vue?vue&type=script&lang=js&"
export * from "./CreateBdoCardFromTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports